import config from "config/config";
import { DocumentService } from "models/wizard/WizardState";
import { apiRequest } from "./apiInterceptor";

export class DocumentServicesAPI {
  static async getDocumentServices(id: string) {
    const result = await apiRequest
      .get(config.api.documentService.get(id))
      .send();
    return result.body;
  }

  static async saveCustomerDocumentArchiveSettings(
    id: string,
    documentServices: DocumentService[]
  ) {
    return await apiRequest
      .put(config.api.documentService.put(id))
      .send(documentServices);
  }
}
